export const BASKET_CATEGORY = 'basket';

export enum BasketAction {
  CREATE = 'create',
  CHECK = 'check',
  CHECKOUT = 'checkout',
  DOWNLOAD = 'download',
  EMAIL = 'email',
}
